import { UnitConversion } from "src/api/client-api/post/postSchema";
import { UnitConverterOption } from "./buildUnitConverterOptions";

export function buildUnitConversion(option: UnitConverterOption, sourceValue: string): UnitConversion {
    return {
        sourceValue,
        sourceUnitCode: option.code,
        sourceUnitAbbreviation: option.abbreviation,
        recipeId: option.recipeId,
        factor: option.factor,
        source: option.source ?? null,
    };
}

export function findConversionSourceOption(
    options: UnitConverterOption[],
    unitConversion: UnitConversion,
): UnitConverterOption | null {
    const option = options.find((candidate) =>
        unitConversion.recipeId === null ?
            candidate.kind === "unit" && candidate.code === unitConversion.sourceUnitCode
        :   candidate.recipeId === unitConversion.recipeId,
    );

    return option ?? null;
}
